import React from "react";
// @material-ui/core components
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import {
    Grid,
    Input,
    MenuItem,
    FormControl,
    InputLabel,
    Select
} from "@material-ui/core";
import InlineDatePicker from "../../utils/InlineDatePicker";
import {appConstants} from "../../_constants";
// import AutocompleteSelect from "../../utils/AutocompleteSelect";

const styles = theme => ({
    container: {
        display: "flex",
        flexWrap: "wrap"
    },
    input: {
        marginTop: "0 !important"
    },
    nb: {
        color: "red",
        fontSize: "12px"
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: "67%"
    },
    root: {
        flexGrow: 1
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: "center",
        color: theme.palette.text.secondary
    },
    formRoot: {
        display: "flex",
        flexWrap: "wrap"
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        width: "100%"
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2
    },
    searchButton: {
        backgroundColor: " #66bb6a"
    },
    airlineSelect: {
        marginTop: "0px",
        width: '100%'
    },
    icon: {
        margin: "8px 0px 8px 0px",
        position: "relative",
        top: "7px",
        paddingLeft: "8px",
    }
});

function editPdm(props) {
    const {
        classes, closeEditModal, isEditModalOpen,
        handleUpdate, newAirlineId, airlines, error, formError, pendingPdmId,
        airlineError, selectChange, destinationData, destinationError,
        passengerCountError, billablePaxError, flightNumbers, flightError, newFlightDate,
        handleDateChange, newLocationId, locationData, billablePaxError2,
        locationError, newDestinationId, newPassengerCount, newBillablePaxCount, user,
        disabled, newFlightNumber
    } = props;


    return (

        <div>

            {/* Edit Data Entry Modal */}
            < Dialog
                fullWidth={true}
                maxWidth={'md'}
                open={isEditModalOpen}
                onClose={closeEditModal}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title" style={{backgroundColor: "#66bb6a"}}>
                    <span style={{color: "white", textTransform: "uppercase"}}> Edit Data Entry</span>
                </DialogTitle>
                <DialogContent style={{marginTop: "20px"}}>
                    <Grid container spacing={24}>
                        <Grid item md={12} xs={12}>

                            {error && <span style={{color: 'red'}}>{formError}</span>}

                            <FormControl className={classNames(classes.airlineSelect, classes.formControl)}>
                                <InputLabel shrink htmlFor="airlineId">Airline</InputLabel>
                                <Select
                                    value={newAirlineId}
                                    onChange={selectChange}
                                    // inputProps={{
                                    //   name: 'airlineId',
                                    //   id: 'airline',
                                    // }}
                                    name="newAirlineId"
                                    input={<Input name="airline" id="airline-label-placeholder"/>}
                                >
                                    <MenuItem value="Placeholder">Select Airline</MenuItem>
                                    {airlines.map((option, i) => (
                                        <MenuItem
                                            key={i}
                                            value={option.AirlineId}
                                            className={classes.select}
                                        >
                                            {option.Airline}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            {airlineError && <span style={{color: 'red'}}>{"Valid Airline is required"}</span>}

                        </Grid>

                        <Grid item md={12} xs={12}>
                            <FormControl
                                className={classNames(classes.airlineSelect, classes.formControl)}
                            >
                                <InputLabel shrink htmlFor="age-label-placeholder">
                                    Flight Number
                                </InputLabel>
                                {/*<AutocompleteSelect*/}
                                    {/*options={flightNumbers.map(option => ({value: option.FlightNumber, label: option.FlightNumber}))}*/}
                                    {/*name={"newFlightNumber"}*/}
                                    {/*handleSelectChange={(e, name) => reactSelectChange(e, name)}*/}

                                {/*/>*/}
                                <Select
                                    value={newFlightNumber}
                                    onChange={selectChange}
                                    input={<Input name="FlightNo" id="flightNo-label-placeholder"/>}
                                    // displayEmpty
                                    name="newFlightNumber"
                                    className={classes.flightNumber}
                                >
                                    <MenuItem value="-1"> All Flights</MenuItem>
                                    {flightNumbers.map((option, i) => (
                                        <MenuItem
                                            key={i}
                                            value={option.FlightNumber}
                                            className={classes.flightNumber}
                                        >
                                            {option.FlightNumber}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            {flightError && <span style={{color: 'red'}}>{"Valid Flight Number is required"}</span>}
                        </Grid>

                        <Grid item md={12} xs={12}>
                            <div className={classNames(classes.airlineSelect, classes.formControl)}>
                                <FormControl className={classNames(classes.airlineSelect, classes.formControl)}>
                                    <InlineDatePicker
                                        Date={newFlightDate}
                                        // handleDateChange={handleDateChange}
                                        handleDateChange={(date) => handleDateChange(date, 'newFlightDate')}
                                        label="Departure Date"
                                    />
                                </FormControl>
                            </div>
                        </Grid>

                        <Grid item md={12} xs={12}>
                            <FormControl className={classNames(classes.airlineSelect, classes.formControl)}>
                                <InputLabel shrink htmlFor="airlineId">Departure Location</InputLabel>
                                <Select
                                    value={newLocationId}
                                    onChange={selectChange}
                                    disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER }
                                    // inputProps={{
                                    //   name: 'airlineId',
                                    //   id: 'airline',
                                    // }}
                                    name="newLocationId"
                                    input={<Input name="newLocation" id="newLocation-label-placeholder"/>}
                                >
                                    <MenuItem value="-1">Select Location</MenuItem>
                                    {locationData.map((option, i) => (
                                        <MenuItem
                                            key={i}
                                            value={option.Code}
                                            className={classes.select}
                                        >
                                            {option.Name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            {locationError &&
                            <span style={{color: 'red'}}>{"Valid Departure Location is required"}</span>}
                        </Grid>

                        <Grid item md={12} xs={12}>
                            <FormControl className={classNames(classes.airlineSelect, classes.formControl)}>
                                <InputLabel shrink htmlFor="airlineId">Destination</InputLabel>
                                {/*<AutocompleteSelect*/}
                                    {/*options={destinationData.map(option => ({value: option.Code, label: option.Name}))}*/}
                                    {/*name={"newDestinationId"}*/}
                                    {/*handleSelectChange={(e, name) => reactSelectChange(e, name)}*/}
                                {/*/>*/}
                                <Select
                                    value={newDestinationId}
                                    onChange={selectChange}
                                    // inputProps={{
                                    //   name: 'airlineId',
                                    //   id: 'airline',
                                    // }}
                                    name="newDestinationId"
                                    input={<Input name="airline" id="airline-label-placeholder"/>}
                                >
                                    <MenuItem value="-1">Destination</MenuItem>
                                    {destinationData.map((option, i) => (
                                        <MenuItem
                                            key={i}
                                            value={option.Code}
                                            className={classes.select}
                                        >
                                            {option.Name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            {destinationError &&
                            <span style={{color: 'red'}}>{"Valid Destination Location is required"}</span>}
                        </Grid>
                        <Grid item md={12} xs={12}>
                            <CustomInput
                                style={{marginTop: "0px", marginBottom: "0px"}}
                                className={classNames(classes.input)}
                                required
                                labelText="Passenger Count"
                                id="newPassengerCount"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={
                                    {
                                        name: "newPassengerCount",
                                        type: "number",
                                        onChange: selectChange,
                                        value: newPassengerCount
                                    }}
                            />
                            {passengerCountError &&
                            <span style={{color: 'red'}}>{"Valid Passenger Count is required"}</span>}
                        </Grid>
                        <Grid item md={12} xs={12}>
                            <CustomInput
                                style={{marginTop: "0px"}}
                                className={classNames(classes.input)}
                                required
                                labelText="Billable Passenger Count"
                                id="newBillablePaxCount"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={
                                    {
                                        name: "newBillablePaxCount",
                                        type: "number",
                                        onChange: selectChange,
                                        value: newBillablePaxCount
                                    }}
                            />
                            {billablePaxError &&
                            <span style={{color: 'red'}}>{"Valid Billable Passenger Count is required"}</span>}
                            {billablePaxError2 &&
                            <span style={{color: 'red'}}>{"Billable Passenger cannot be greater than Passenger Count"}</span>}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeEditModal} color="danger">
                        Cancel
                    </Button>
                    <Button disabled={disabled} onClick={() => handleUpdate(pendingPdmId)} color="primary" autoFocus>
                        Update
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default (withMobileDialog()(withStyles(styles)(editPdm)));



// WEBPACK FOOTER //
// ./src/views/PDM/EditPdm.jsx